import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import { Box, Paper, TextField, Button, Typography,CircularProgress } from '@mui/material';



const QRCodeVerification = () => {
  
    const [contact, setContact] = useState('');
    const [step, setStep] = useState(1);
    const [eventId, setEventId] = useState(null);
    const location = useLocation();
    const [userId, setUserId] = useState('');
    const [eventName, setEventName] = useState('');
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);

    const getEventDetailsApiUrl = process.env.REACT_APP_GET_EVENT_DETAILS_API
    const verifyAccessUserApiUrl = process.env.REACT_APP_VERIFY_ACCESS_USER_API
    const requestAccessApiUrl = process.env.REACT_APP_REQUEST_ACCESS_API
    const url = `${process.env.REACT_APP_VIDEOS_API_URL}/${userId}/${eventName}/${fileName}`;


  useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const eventIdParam = queryParams.get('eventId');
        setEventId(eventIdParam);
        if (eventIdParam) {
          fetchEventDetails(eventIdParam);
        }
      }, [location]);



      const fetchEventDetails = async (eventId) => {
        try {
          const response = await axios.post(getEventDetailsApiUrl, { eventId });
          if (response.data.success) {
            setUserId(response.data.userId);
            setEventName(response.data.eventName);
            setFileName(response.data.fileName);
          } else {
            alert(response.data.message || 'Failed to fetch event details.');
          }
        } catch (error) {
          console.error('Error fetching event details:', error);
        }
      };


const handleAccessUsers = async () => {
  try {
    const response = await axios.post(verifyAccessUserApiUrl, { contact, eventId });
    if (response.data.success === 'True') {
     
       // Fetch the actual video URL from your Flask backend
       const videoResponse = await axios.get(url);
 
       if (videoResponse.status === 200 && videoResponse.data?.videoUrl) {
         // Redirect user to the CloudFront video URL
         window.location.href = videoResponse.data.videoUrl;
       } else {
         alert('Failed to retrieve the video link.');
       }
    } else {
      alert('User not verified. Please click on Request Access.');
      setStep(2);  // Direct to step 2 to show "Request Access" button
    }
  } catch (error) {
    alert('An error occurred. Please try again.');
    console.error('Error verifying user:', error);
  }
};

const handleRequestAccess = async () => {
  setLoading(true); // Start loading
  try {
    const response = await axios.post(requestAccessApiUrl, { contact, eventId, userId});
    if (response.data.success === 'True') {
      alert('Access request sent to the owner. Waiting for the approval');
      setStep(1)
    } else {
      alert('Failed to send access request. Please try again.');
    }
  } catch (error) {
    console.error('Error requesting access:', error);
    alert('An error occurred. Please try again.');
  }finally {
    setLoading(false); // Stop loading
  }
};





return (
  <Box sx={{ position: 'relative', padding: '20px', maxWidth: '400px', margin: 'auto', marginTop: '50px' }}>
    <Paper sx={{ padding: 4, textAlign: 'center' }}>
      {step === 1 ? (
        <Box>
          <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>Enter Contact</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            placeholder="Enter email or phone number"
            sx={{ marginBottom: 2 }}
          />
          <Button variant="contained" color="primary" onClick={handleAccessUsers} sx={{ width: '100%', fontWeight: 'bold' }}>
            Submit
          </Button>
        </Box>
      ) : (
        <Box>
          <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>Request Access</Typography>
          <Button
        variant="contained"
        color="secondary"
        onClick={handleRequestAccess}
        sx={{ width: '100%', fontWeight: 'bold', marginTop: 2 }}
        disabled={loading} 
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Request Access'}
      </Button>
        </Box>
      )}
    </Paper>
  </Box>
);
}

export default QRCodeVerification;









